import PersonalDetailsComponent from './Personal/PersonalDetailsComponent';

export default function Personal() {
  return (
    <div className="relative max-w-5xl mb-20 md:mb-0">
      <PersonalDetailsComponent />
    </div>
  );
}
